export default __webpack_public_path__ + "static/media/mail-icon.df327030.svg";